const LOGO =
    "https://customer-assets.emergentagent.com/job_74007a75-e0c2-4452-bdc7-515e3dc56401/artifacts/qxxe8th0_K%20%E2%80%A2TEAM.png";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative z-10 mt-24 md:mt-40 bg-[var(--ink)] text-[var(--bg-base)]"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-7">
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/55 mb-6">
                            — A Working Creative Society
                        </p>
                        <p className="font-serif-display text-3xl md:text-5xl leading-[1.08] tracking-tight max-w-2xl">
                            Art and music are how we tell the truth.
                            <span className="italic text-[var(--ochre)]">
                                {" "}
                                Dream out loud.
                            </span>
                        </p>

                        {/* CONNECT — directly under the manifesto */}
                        <div className="mt-12 md:mt-16">
                            <ul className="space-y-2 font-mono-acc text-sm md:text-base">
                                <li>
                                    <a
                                        href="mailto:connect@hellokteam.com"
                                        data-testid="footer-link-info"
                                        className="hover:text-[var(--ochre)] transition-colors"
                                    >
                                        connect@hellokteam.com
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="mailto:Linda@hellokteam.com"
                                        data-testid="footer-link-linda"
                                        className="hover:text-[var(--ochre)] transition-colors"
                                    >
                                        Linda@hellokteam.com
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="mailto:Agnes@hellokteam.com"
                                        data-testid="footer-link-agnes"
                                        className="hover:text-[var(--ochre)] transition-colors"
                                    >
                                        Agnes@hellokteam.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="md:col-span-4 md:col-start-9">
                        <ul className="space-y-2 font-mono-acc text-sm">
                            <li>
                                <a
                                    href="/"
                                    className="hover:text-[var(--ochre)] transition-colors"
                                >
                                    01 — Home
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/events"
                                    className="hover:text-[var(--ochre)] transition-colors"
                                >
                                    02 — Events
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/shop"
                                    className="hover:text-[var(--ochre)] transition-colors"
                                >
                                    03 — Shop
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/fly-muse"
                                    className="hover:text-[var(--ochre)] transition-colors"
                                >
                                    04 — The Fly Muse
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Big wordmark */}
                <div className="mt-20 md:mt-32 border-t border-[var(--bg-base)]/20 pt-10 flex items-end justify-between gap-8">
                    <img
                        src={LOGO}
                        alt="K•TEAM"
                        className="h-16 md:h-24 w-auto opacity-90"
                        style={{ filter: "brightness(0) invert(1)" }}
                    />
                    <div className="text-right">
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/55">
                            © K-Team Collective
                        </p>
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/55 mt-1">
                            MMXXV / All Rights Reserved
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
